import { useEffect } from "react";
import ProviderDetailsComponent from "../../components/providerComponents/providerDetails/ProviderDetailsComponent";
import { useProviderContext } from "../../components/providerComponents/context/providerContext";

export default function ProviderDetailsPage() {
  const { setHeaderText } = useProviderContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Provider Details",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ProviderDetailsComponent disabled={false} />
    </>
  );
}
